import { render, staticRenderFns } from "./TouchService.vue?vue&type=template&id=98e96c3c&lang=pug"
import script from "./TouchService.vue?vue&type=script&lang=js"
export * from "./TouchService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports